import {
  HYDROPOWERLIST,
} from '../actions/hydropower';
import {reducerPackage} from "../../utils";

export const hydropowerList = reducerPackage(HYDROPOWERLIST);
